<template>
  <BreadCrumb PageTitle="Nouveau bon de paiment (Livreurs)" />
  <NewPayment />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import NewPayment from "@/components/Notes/Payments/Driver/NewPayment.vue";

export default defineComponent({
  name: "NewPaymentPage",
  components: {
    BreadCrumb,
    NewPayment,
  },
});
</script>
